import * as React from 'react';

import { cn } from '../../../libs/utils';

export const BaseOverlay = React.forwardRef<
  React.ElementRef<'div'>,
  React.ComponentPropsWithoutRef<'div'> & {
    outSideClickAction?: () => void;
  }
>(({ className, outSideClickAction, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn('fixed inset-0 z-overlay bg-neutral-background-dimmed-main', className)}
      {...props}
      onClick={() => {
        outSideClickAction?.();
      }}
    />
  );
});

BaseOverlay.displayName = 'BaseOverlay';
